let EventUtilWrapper = <VideoJSEventUtil>require('videojs/es5/utils/events.js');

export default EventUtilWrapper;


// WEBPACK FOOTER //
// ./src/app/utils/wrappers/Events.ts